import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Primary, Text, TextLink } from "@cinch-labs/design-system";
import FocusLock from "react-focus-lock";
import styles from "./cookie-banner.module.css";
import { datadogRum } from "@datadog/browser-rum";
var CookieBanner = function(param) {
    var handleManageSettingsButtonClick = param.handleManageSettingsButtonClick, handleAcceptCookiesButtonClick = param.handleAcceptCookiesButtonClick, isPreferencesModalOpen = param.isPreferencesModalOpen, hydrated = param.hydrated;
    return /*#__PURE__*/ _jsx(FocusLock, {
        noFocusGuards: true,
        disabled: isPreferencesModalOpen,
        children: /*#__PURE__*/ _jsx("div", {
            id: "cookie-banner",
            role: "dialog",
            className: styles.cookieBanner,
            "data-testid": hydrated ? "cookie-banner" : "",
            "aria-labelledby": "cookie-banner-text",
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.cookieBannerInner,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.cookieBannerContent,
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                element: "h2",
                                fontSize: "xxl",
                                fontWeight: "bold",
                                lineHeight: "display",
                                className: styles.cookieBannerTitle,
                                children: "Your privacy on cinch"
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                id: "cookie-banner-text",
                                fontSize: "s",
                                children: [
                                    "We use some necessary cookies to make our site work. However, we also use additional cookies to understand your journey on cinch and how we can improve. These will only be set if you accept them. For more details, visit our",
                                    " ",
                                    /*#__PURE__*/ _jsx(TextLink, {
                                        href: "/policies/cookie-policy",
                                        hasNoLine: true,
                                        children: "cookie page"
                                    }),
                                    ".",
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.cookieBannerButtons,
                        children: [
                            /*#__PURE__*/ _jsx(Primary, {
                                isFullWidth: true,
                                "data-testid": "accept",
                                size: "large",
                                onClick: function(event) {
                                    event.preventDefault();
                                    datadogRum.addAction("Cookie banner accept click");
                                    localStorage.setItem("cookieConsentPreferences", "true");
                                    handleAcceptCookiesButtonClick && handleAcceptCookiesButtonClick(true);
                                },
                                children: "Accept additional cookies"
                            }),
                            /*#__PURE__*/ _jsx(Primary, {
                                isFullWidth: true,
                                "data-testid": "edit-preferences-button",
                                size: "large",
                                onClick: function(event) {
                                    event.preventDefault();
                                    datadogRum.addAction("Cookie banner manage settings click");
                                    handleManageSettingsButtonClick && handleManageSettingsButtonClick();
                                },
                                children: "Manage settings"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
export default CookieBanner;
